import { Redirect } from "react-router-dom";

import { getLocation } from "@src/appV2/redesign/utils/routes";

interface LegacyAgentProfileRedirectProps {
  workerId: string;
}

export function LegacyAgentProfileRedirect({ workerId }: LegacyAgentProfileRedirectProps) {
  return <Redirect to={getLocation("document", { pathParams: { userId: workerId } })} />;
}
